import { CommonModule } from '@angular/common';
import { Component, DOCUMENT, inject, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { FadeInReveal } from '../../../../directives/fade-in-reveal';

@Component({
  selector: 'app-service-child',
  imports: [CommonModule, RouterLink, FadeInReveal],
  templateUrl: './service-child.html',
  styleUrls: ['./service-child.less', '../services.less'],
})
export class ServiceChild implements OnInit {
  private dom = inject(DOCUMENT);

  ngOnInit() {
    const schema = {
      '@context': 'https://schema.org',
      '@type': 'Service',
      name: 'Terapia infantil',
      description:
        'Terapia psicológica infantil basada en el juego, el vínculo y el acompañamiento emocional del niño y su familia.',
      provider: { '@id': 'https://anapellonpsicologa.com' },
      areaServed: [
        {
          '@type': 'AdministrativeArea',
          name: 'Santander',
        },
        {
          '@type': 'Country',
          name: 'España',
        },
      ],
      availableChannel: [
        {
          '@type': 'ServiceChannel',
          serviceLocation: {
            '@type': 'Place',
            name: 'Consulta presencial en Santander',
          },
        },
        {
          '@type': 'ServiceChannel',
          serviceUrl: 'https://anapellonpsicologa.com/contacto',
        },
      ],
    };

    const script = this.dom.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schema);
    this.dom.head.appendChild(script);
  }
}
